export const PRINT_CART_STORAGE_KEY = 'bloomup.printCart.v2';

const REQUIRED_STRING_FIELDS = [
  'clientLineItemId',
  'printId',
  'fulfillmentKind',
  'outputFormat',
  'format',
  'productType',
  'contentFinish',
  'previewToken',
  'printTitle',
];

const getStorage = (storage) => storage || window.localStorage;

export const isValidPrintCartLine = (line) =>
  Boolean(
    line &&
      typeof line === 'object' &&
      !Array.isArray(line) &&
      REQUIRED_STRING_FIELDS.every((field) => typeof line[field] === 'string') &&
      (line.binding === null || typeof line.binding === 'string') &&
      Number.isInteger(line.quantity) &&
      line.quantity >= 1 &&
      Number.isInteger(line.totalPages) &&
      line.totalPages >= 1 &&
      typeof line.displayPrice === 'number' &&
      Number.isFinite(line.displayPrice)
  );

export const loadPrintCart = (storage) => {
  try {
    const serialized = getStorage(storage).getItem(PRINT_CART_STORAGE_KEY);
    if (serialized === null) return [];

    const cart = JSON.parse(serialized);
    return Array.isArray(cart) && cart.every(isValidPrintCartLine) ? cart : [];
  } catch (error) {
    return [];
  }
};

export const shouldOpenRestoredPrintCart = (cart) => Array.isArray(cart) && cart.length > 0;

export const savePrintCart = (cart, storage) => {
  if (!Array.isArray(cart) || !cart.every(isValidPrintCartLine)) {
    return { ok: false, reason: 'invalid-cart' };
  }

  try {
    const target = getStorage(storage);
    const serialized = JSON.stringify(cart);
    target.setItem(PRINT_CART_STORAGE_KEY, serialized);
    if (target.getItem(PRINT_CART_STORAGE_KEY) !== serialized) {
      return { ok: false, reason: 'verification-failed' };
    }
    return { ok: true };
  } catch (error) {
    return { ok: false, reason: 'storage-error' };
  }
};

export const clearPrintCart = (storage) => {
  try {
    getStorage(storage).removeItem(PRINT_CART_STORAGE_KEY);
    return { ok: true };
  } catch (error) {
    return { ok: false, reason: 'storage-error' };
  }
};

const decodePreviewPayload = (token) => {
  try {
    const encodedPayload = token.split('.')[0];
    if (!encodedPayload) return null;
    const normalized = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    return JSON.parse(window.atob(padded));
  } catch (error) {
    return null;
  }
};

export const hasCurrentPreview = (line, now = Date.now()) => {
  const payload = isValidPrintCartLine(line) ? decodePreviewPayload(line.previewToken) : null;
  return Boolean(
    payload &&
      typeof payload.expiresAt === 'number' &&
      payload.expiresAt > now &&
      payload.printId === line.printId &&
      payload.format === line.format &&
      payload.productType === line.productType &&
      payload.totalPages === line.totalPages
  );
};
